module.exports = __webpack_public_path__ + "c74260cde1a16b48febba358704ac4b6.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Montserrat/Montserrat-SemiBold.woff2
// module id = 1806
// module chunks = 1